<template>
    <Teleport to="body">
        <Transition name="toast">
            <div v-if="visible"
                class="fixed top-10 left-1/2 -translate-x-1/2 z-[2999] flex items-center px-6 py-4 rounded-2xl shadow-2xl border backdrop-blur-md transition-all duration-300 min-w-[240px]"
                :class="[
                    type === 'success'
                        ? 'bg-green-50/90 border-green-200 text-green-900'
                        : type === 'warning'
                            ? 'bg-amber-50/90 border-amber-200 text-amber-900'
                            : 'bg-red-50/90 border-red-200 text-red-900'
                ]">
                <span class="mr-3 flex-shrink-0">
                    <svg v-if="type === 'success'" class="w-6 h-6 text-green-600" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                        <polyline points="22 4 12 14.01 9 11.01"></polyline>
                    </svg>

                    <svg v-else-if="type === 'warning'" class="w-6 h-6 text-amber-600" viewBox="0 0 24 24"
                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M10.3 2.9 1.8 17a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 2.9a2 2 0 0 0-3.4 0Z"></path>
                        <line x1="12" y1="9" x2="12" y2="13"></line>
                        <line x1="12" y1="17" x2="12.01" y2="17"></line>
                    </svg>

                    <svg v-else class="w-6 h-6 text-red-600" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="15" y1="9" x2="9" y2="15"></line>
                        <line x1="9" y1="9" x2="15" y2="15"></line>
                    </svg>
                </span>

                <span class="font-bold text-[15px] tracking-tight">{{ message }}</span>
            </div>
        </Transition>
    </Teleport>
</template>

<script setup>
/* global defineProps */
defineProps({
    visible: Boolean,
    message: String,
    type: {
        type: String,
        default: 'success'
    }
});
</script>

<style scoped>
.toast-enter-active,
.toast-leave-active {
    transition: all 0.4s cubic-bezier(0.18, 0.89, 0.32, 1.28);
}

.toast-enter-from {
    transform: translate(-50%, -40px);
    opacity: 0;
}

.toast-leave-to {
    transform: translate(-50%, -20px);
    opacity: 0;
}
</style>
